import { EditorState, EditorStatus, LoadedState, SaveErrorValue, ErrorMap } from "app/pages/DiscountEditor/modules/Editor/state";
import { Action, ActionType } from "app/pages/DiscountEditor/actionTypes";
import { SaveDiscountErrorCategory } from "app/shared/model/SaveDiscountResultDto";

export function reducer(state: EditorState|undefined, action: Action) : EditorState {
    if (state === undefined) {
        state = {status: EditorStatus.NoRecord};
    }

    if ((action as any).type === 'PageLoadedSuccessfully')
        return state;

    switch(action.type) {
        case ActionType.PageLoaded:
            return {
                status: EditorStatus.Loaded,
                errors: {},
                id: action.data.id,
                saveError: SaveErrorValue.NoError,
                changeNumber: 0,
                savedNumber: 0,
                savingNumber: undefined,
                showSuccessMessage: false
            };

        case ActionType.SaveStarted:
            if (state.status == EditorStatus.NoRecord) 
                return state;
            return {
                ... state,
                saveError: state.saveError,
                savingNumber: state.changeNumber,
                showSuccessMessage: false
            }

        case ActionType.SaveSuccessful:
            if (state.status == EditorStatus.NoRecord) 
                return state;
            return {
                ... state,
                id: action.result.discountId.toString(),
                savingNumber: undefined,
                errors: {},
                saveError: SaveErrorValue.NoError,
                savedNumber: state.savingNumber||state.savedNumber,
                showSuccessMessage: true
            }

        case ActionType.SaveInvalid:
            if (state.status == EditorStatus.NoRecord) 
                return state;

            const newErrors: ErrorMap = {};
            action.result.errors.forEach(e => {
                let list = newErrors[e.category];
                if (!list) {
                    list = [];
                    newErrors[e.category] = list;
                }
                list.push(e.message);
            })

            return {
                ... state,
                saveError: SaveErrorValue.Invalid,
                errors: newErrors,
                savingNumber: undefined,
                showSuccessMessage: false
            }

        case ActionType.SaveFailed:
            if (state.status == EditorStatus.NoRecord) 
                return state;
            return {
                ... state,
                saveError: SaveErrorValue.Error,
                errors: {},
                savingNumber: undefined,
                showSuccessMessage: false
            }

        case ActionType.ChangeSchoolGroupOpenState:
        case ActionType.AddOfferingsForSchool:
        case ActionType.OfferingsLoadError:
        case ActionType.OfferingsLoadStarted:
        case ActionType.AgentSearchChanged:
        case ActionType.AgentSearchFailed:
        case ActionType.AgentSearchResultsLoaded:
        case ActionType.AgentOfficesLoaded:
        case ActionType.ShowOrHideAgentOffices:
        case ActionType.ShowDeleteDiscountActionConfirmation:
        case ActionType.ShowAddDiscountActionWizard:
        case ActionType.StartEditingDiscountAction:
        case ActionType.CancelShowDeleteDiscountActionConfirmation:
        case ActionType.CancelAddOrUpdateDiscountAction:
            return state;

        case ActionType.SetSelectedDivisions:
            if (state.status === EditorStatus.NoRecord)
                return state;

            const rawIds = action.ids;
            const divisionIds = Array.isArray(rawIds)
                ? rawIds.map((id: number) => Number(id)).filter((n: number) => !Number.isNaN(n))
                : rawIds != null
                    ? [Number(rawIds)].filter((n: number) => !Number.isNaN(n))
                    : [];
            const hasSelectedDivisions = divisionIds.length > 0;
            const hasDivisionError = state.errors && state.errors[SaveDiscountErrorCategory.Divisions];
            
            if (hasSelectedDivisions && hasDivisionError) {
                const newErrors = { ...state.errors };
                delete newErrors[SaveDiscountErrorCategory.Divisions];
                const hasOtherErrors = Object.keys(newErrors).length > 0;
                return {
                    ...state,
                    errors: newErrors,
                    saveError: hasOtherErrors ? state.saveError : SaveErrorValue.NoError,
                    changeNumber: state.changeNumber + 1
                };
            }
            return {
                ...state,
                changeNumber: state.changeNumber + 1,
                showSuccessMessage: false
            };

        default: 
            if (state.status === EditorStatus.NoRecord)
                return state;

            const updateBecauseOfSavedNumber = 
                state.changeNumber === state.savedNumber;

            const updateBecauseOfSavingNumber = 
                state.savingNumber !== undefined &&
                state.savingNumber === state.changeNumber;
            
            if (!updateBecauseOfSavedNumber && !updateBecauseOfSavingNumber)
                return state;

            return {
                ... state,
                changeNumber: state.changeNumber + 1,
                showSuccessMessage: false
            }
    }
}